// src/contexts/AuthContext.js - Fichier pour le Context uniquement
import { createContext } from 'react';

export const AuthContext = createContext(null);